import React from "react";
import { ExamResultsDTO } from "../../../models/dtos/exams/exam/ExamResultsDTO";
import { DurationView } from "../student-exam-summary/StudentExamSummary.models";
import StudentExamSummaryImage from '../../../assest/images/card-image/ItemAvatar07.png';
import { NavLink } from "react-router-dom";
import ExamResultService from "../../../services/exam/ExamResultService";
import moment from "moment";
import { ExamTypes } from "../../../models/interfaces/exams/exam/ExamTypes";



export default class ExamSummary extends React.PureComponent<{ examResultId: number; showOptions: boolean }, { resultData?: ExamResultsDTO; responseDuration: DurationView; }> {

    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.examResultService = new ExamResultService();
        this.state = { responseDuration: { responseDurationHour: '', responseDurationMinute: '', responseDurationSecond: '' } }
    }
    componentDidMount = () => {
        if (this.props.examResultId !== null && this.props.examResultId !== undefined)
            this.getData();
    }

    componentDidUpdate = (prevProps: any) => {
        if (prevProps.examResultId !== this.props.examResultId)
            this.getData();
    }

    getData = () => {
        let self = this;
        this.examResultService.getExamResult(this.props.examResultId).then(function (response) {

            let resultData = response;
            if (resultData.responseDuration == null) {

                self.setState({
                    resultData: resultData, responseDuration: {
                        responseDurationHour: resultData.responseDurationHour === 0 ? "00" :
                            resultData.responseDurationHour > 0 && resultData.responseDurationHour < 10 ? "0" + resultData.responseDurationHour.toString()
                                : resultData.responseDurationHour.toString(),
                        responseDurationMinute: resultData.responseDurationMinute === 0 ? "00" :
                            resultData.responseDurationMinute > 0 && resultData.responseDurationMinute < 10 ? "0" + resultData.responseDurationMinute.toString()
                                : resultData.responseDurationMinute.toString(),
                        responseDurationSecond: "37"
                    }
                });

            }
            else {
                var responseDuration = moment(resultData.responseDuration)
                var hour = responseDuration.hours();
                var minute = responseDuration.minutes();
                var second = responseDuration.seconds();
                let ResponseDurationHour = hour < 9 ? `0${hour}` : hour.toString();
                let ResponseDurationMinute = minute < 9 ? `0${minute}` : minute.toString();
                let ResponseDurationSecond = second < 9 ? `0${second}` : second.toString();

                self.setState({
                    resultData: resultData, responseDuration: {
                        responseDurationHour: ResponseDurationHour,
                        responseDurationMinute: ResponseDurationMinute,
                        responseDurationSecond: ResponseDurationSecond
                    }
                });
            }
        });

    }
    render(): React.ReactNode {
        let { resultData, responseDuration } = this.state;
        let { showOptions } = this.props;
        let timeContent;
        let content;

        if (responseDuration.responseDurationHour === "00" && responseDuration.responseDurationMinute === "00")
            timeContent = (<>
                <label className="dir-ltr">کمتر از یک دقیقه</label>
            </>);
        else
            timeContent = (<>
                <label className="dir-ltr">{responseDuration.responseDurationHour}:{responseDuration.responseDurationMinute}:{responseDuration.responseDurationSecond}</label>
            </>);

        if (resultData !== null && resultData !== undefined)
            content = (<>
                <div className="col-12 tk-padding-top">
                    <div className="tk-card">
                        {showOptions ? (<div className="card-icon">
                            <img src={StudentExamSummaryImage} alt={"student exam summary"} />
                        </div>) : (<></>)}
                        <div className="card-title">
                            <label>
                                {resultData.examTitle}
                            </label>
                        </div>
                        <div className="col-12 user-info">
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label>رشته</label>
                                </div>
                                <div className="col-6 notspace info">
                                    <label>{resultData.studentField}</label>
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label>پایه</label>
                                </div>
                                <div className="col-6 notspace info">
                                    <label>{resultData.studentBaseTitles}</label>
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label> تعداد سوالات</label>
                                </div>
                                <div className="col-6 notspace info">
                                    <label>{resultData.totalQuestions}</label>
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label> مدت پاسخگویی </label>
                                </div>
                                <div className="col-6 notspace info">
                                    {timeContent}
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-7 notspace">
                                    <label> تعداد سوالات صحیح  </label>
                                </div>
                                <div className="col-5 notspace info">
                                    <label>{resultData.correctAnswers} </label>
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label> تعداد سوالات غلط  </label>
                                </div>
                                <div className="col-6 notspace info">
                                    <label>{resultData.wrongAnswers} </label>
                                </div>
                            </div>
                            <div className="tk-inline">
                                <div className="col-6 notspace">
                                    <label> تعداد سوالات نزده  </label>
                                </div>
                                <div className="col-6 notspace info">
                                    <label>{resultData.nonAnswers}</label>
                                </div>
                            </div>
                            {
                                (resultData.examType != ExamTypes.ExhaustiveTest) &&
                                <div className="tk-inline">
                                    <div className="col-6 notspace">
                                        <label>درصدعملکرد</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label className="dir-ltr">% {resultData.examPrecent}</label>
                                    </div>
                                </div>
                            }
                            {
                                (resultData.examType == ExamTypes.ExhaustiveTest) &&
                                <>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>تراز</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>به زودی</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>رتبه</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>به زودی</label>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {showOptions ? (<div className="col-12 tk-padding-bottom">
                            <NavLink to={"/CurrentExam"} className="tk-inline">
                                <button className="btn btn-outline-primary" style={{ width: "100%" }}>بازگشت</button>
                            </NavLink>
                        </div>) : (<></>)}

                    </div>
                </div>
            </>);
        else content = (<></>);


        return (<>
            {content}
        </>);
    }

}